import CompLayout from "@/pcomponents/comp/layout/layout";
import ListMoneyArea from "@/pages/comp/supply/simple_trade/common/list_money";

function ListMoneyPage() {

  return (
    <CompLayout isConTitle={false}>
      <ListMoneyArea></ListMoneyArea>
    </CompLayout>
  );
};
export default ListMoneyPage;